import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Save, Loader2 } from "lucide-react";

export default function PlansEditor({ plans, drafts, onDraftChange, savingKey, onSave }) {
  return (
    <div className="glass-card overflow-hidden" data-testid="admin-plans-editor">
      <div className="section-accent p-5 sm:p-6">
        <h2 className="font-heading text-lg font-semibold text-slate-100">Editor de Planos</h2>
        <p className="text-xs text-slate-500 mt-1">Altere o valor mensal (R$) e o limite de chips. O checkout do cliente reflete os novos valores em tempo real.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-5 sm:p-6">
        {plans.map((p) => {
          const d = drafts[p.key] || {};
          return (
            <div key={p.key} className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-4" data-testid={`admin-plan-edit-${p.key}`}>
              <p className="font-semibold text-slate-100 mb-1">{p.label}</p>
              <p className="text-[11px] text-slate-500 mb-4 font-mono">chave: {p.key}</p>
              <div className="space-y-3">
                <div>
                  <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">Preço mensal (R$)</label>
                  <Input type="number" min={1} step="0.01" value={d.price ?? ""}
                    onChange={(e) => onDraftChange(p.key, "price", e.target.value)}
                    data-testid={`admin-plan-price-input-${p.key}`}
                    className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono mt-1 focus-visible:ring-2 focus-visible:ring-emerald-500" />
                </div>
                <div>
                  <label className="text-xs font-semibold uppercase tracking-wider text-slate-400">Limite de chips</label>
                  <Input type="number" min={1} max={500} value={d.chip_limit ?? ""}
                    onChange={(e) => onDraftChange(p.key, "chip_limit", e.target.value)}
                    data-testid={`admin-plan-limit-input-${p.key}`}
                    className="bg-slate-800/60 border-slate-700 text-slate-100 font-mono mt-1 focus-visible:ring-2 focus-visible:ring-emerald-500" />
                </div>
                <Button onClick={() => onSave(p.key)} disabled={savingKey === p.key}
                  data-testid={`admin-plan-save-button-${p.key}`}
                  className="w-full bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold h-9 text-sm">
                  {savingKey === p.key ? <Loader2 className="w-4 h-4 animate-spin" /> : (<><Save className="w-4 h-4 mr-2" /> Salvar plano</>)}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
